export default "__VITE_ASSET__bfc74ec9__"